import { EstateTaskGroup, EstateTaskInstance, EstateType } from 'queries';

import Modal from 'common/modal';

import EstateTaskCustomForm from './estate-task-custom-form';

type Props = {
  estateTaskGroup: EstateTaskGroup;
  estateId: string;
  estateType: EstateType;
  groupedEstateTaskInstances: { [key: string]: EstateTaskInstance[] };
  // eslint-disable-next-line @typescript-eslint/ban-types
  addGroupedEstateTaskInstance: Function;
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onExitClick?: Function;
};

export default function EstateTaskCustomModal({
  estateTaskGroup,
  estateId,
  estateType,
  groupedEstateTaskInstances,
  addGroupedEstateTaskInstance,
  showModal,
  setShowModal,
  onExitClick,
}: Props) {
  const _onExitClick = () => {
    onExitClick && onExitClick();
  };

  return (
    <Modal
      setShowModal={setShowModal}
      onExitClick={_onExitClick}
      showModal={showModal}
      showActions={false}
      content={
        <EstateTaskCustomForm
          estateTaskGroup={estateTaskGroup}
          estateId={estateId}
          estateType={estateType}
          groupedEstateTaskInstances={groupedEstateTaskInstances}
          addGroupedEstateTaskInstance={addGroupedEstateTaskInstance}
          onExitClick={_onExitClick}
        />
      }
      loading={false}
      actionDisabled={false}
      maxWidth="md"
    />
  );
}
